import { Actions, AppContext, ContextProvider, Events } from "@Context/common/general/context";
import DialogManagerProvider from "@Context/common/general/dialog-manager-context";
import { NotificationDialogProvider } from "@Context/common/general/notification-dialog-context";
import { ReleaseNotesProvider } from "@Context/common/release-notes/release-notes-context";
import "@Globals";
import { I18nProvider } from "@i18n";
import VrApp from "@Routes/vr-app";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/es";
import { Suspense, useContext, useEffect } from "react";
import * as ReactDOMClient from "react-dom/client";
import "./i18next";
import "./index.css";
import initSentry from "./init-sentry";

initSentry({
  dsn: "https://71a7f957e248625e3b58daeac3c3694a@o952540.ingest.us.sentry.io/4507604679000064",
  enableReplayCapture: false,
});

dayjs.locale(navigator.language);

const VrAppMount = () => {
  const { dispatch } = useContext(AppContext);
  const updateConsent = (flag: boolean) => {
    dispatch({
      type: Actions.AppActions.UpdateConsent,
      payload: { consent: flag },
    });
  };
  useEffect(() => {
    Events.auth.loginSuccess.uniq(() => updateConsent(true));
    Events.auth.logout.uniq(() => updateConsent(false));
  }, []);
  return <VrApp />;
};

(() => {
  ReactDOMClient.createRoot(document.getElementById("root")!).render(
    <ContextProvider>
      <I18nProvider>
        <NotificationDialogProvider>
          <ReleaseNotesProvider>
            <DialogManagerProvider>
              <Suspense fallback={null}>
                <VrAppMount />
              </Suspense>
            </DialogManagerProvider>
          </ReleaseNotesProvider>
        </NotificationDialogProvider>
      </I18nProvider>
    </ContextProvider>
  );
})();
